export default function fullscreenimg(md) {
    const originalImageRenderer = md.renderer.rules.image;

    md.renderer.rules.image = (tokens, idx, options, env) => {
        const ext = tokens[idx].src && tokens[idx].src.substring(tokens[idx].src.length - 3);
        if(ext === 'mp4') {
            return '<video src="' + tokens[idx].src + '" autoplay></video>';
        }
        else {
            return '<div class="imgcontainer" allowfullscreen><div class="center">' + originalImageRenderer(tokens, idx, options, env) + '</div></div>';
        }
    };
}
